import type {
	PlaceOrModifyOrdersRequest,
	PlaceOrModifyOrdersResponse,
	GetAllOrdersRequest,
	CancelOrdersRequest,
	CancelOrdersResponse,
	Holding,
	TradingAccountMargin,
	GetTradingAccountMarginRequest
} from '../proto/generated/trading-bridge'
import type { MarginFromBrokerRequest, MarginFromBrokerResponse, Order } from '../proto/generated/order'
import type { PositionRequest, PositionResponse } from '../proto/generated/position'
import { Security } from '../proto/generated/security'
import {
	LoginRequest,
	AuthProviderLoginUrlResponse,
	LoginResponse,
	LoginWithMobileRequest,
	LoginWithMobileResponse,
	User,
	ValidateThirdPartyTokenRequest,
	UserSignUpRequest,
	ForgetPasswordRequest,
	VerifyMobileLoginRequest,
	GetActiveSessionsResponse,
	OperationResponse,
} from '../proto/generated/identity'

export enum BackendProvider {
	TICK2TRADE = 'tick2trade',
	SHOONYA = 'shoonya'
}

export interface BackendConfig {
	provider: BackendProvider
	baseUrl: string
	providerUrl: string
	wsUrl?: string
	apiKey?: string
	headers?: Record<string, string>
}

export interface IBackendAdapter {
	genrateLocalSecurityMap(security: Security): void
	getProvider(): BackendProvider
	getBaseUrl(): string
	getProviderUrl(): string
	getWebSocketUrl(): string

	transformRequest<T = any>(endpoint: string, data: T, method: string): {
		url: string
		data: any
		headers?: Record<string, string>
	}

	transformResponse<T = any>(response: any, endpoint: string): T

	transformError(error: any): any

	logout(): void

	placeOrModifyOrder(request: PlaceOrModifyOrdersRequest): Promise<PlaceOrModifyOrdersResponse>
	getOrders(request: GetAllOrdersRequest): Promise<Order[]>
	cancelOrder(request: CancelOrdersRequest): Promise<CancelOrdersResponse>
	getPositions(request: PositionRequest): Promise<PositionResponse>
	getPlacedOrder(params: any): Promise<Order>
	getHoldings(accountId: string | undefined): Promise<Holding[]>

	syncTradingAccountMargin(request: GetTradingAccountMarginRequest): Promise<TradingAccountMargin>
	getRequiredMargin(request: MarginFromBrokerRequest): Promise<MarginFromBrokerResponse>
	getLoginUrl(body: any): Promise<AuthProviderLoginUrlResponse>
	loginWithMail(body: LoginRequest): Promise<LoginResponse>
	loginWithMobile(body: LoginWithMobileRequest): Promise<LoginWithMobileResponse>
	verifyMobileLogin(body: VerifyMobileLoginRequest): Promise<LoginResponse>
	signUpWithMail(userSignUpRequest: UserSignUpRequest): Promise<LoginResponse>
	sendEmailOtp(email: string, options?: { purpose?: string }): Promise<any>
	forgetPassword(body: ForgetPasswordRequest): Promise<User>
	validateToken(body: ValidateThirdPartyTokenRequest): Promise<LoginResponse>
	getActiveSessions(): Promise<GetActiveSessionsResponse>
	revokeSession(deviceId: string): Promise<OperationResponse>
}
